module.exports = __webpack_public_path__ + "194a6b1b2f019d13f2e3ccd6051b494d.svg";